import type {
  Preset,
  SectionSet,
  TokenSet,
} from "@tento-ui/brand/page-engine.types";
import type { ThemeRef } from "@tento-ui/brand/page-model";

import type { PageEngineNodeProps } from "./to-props";

export type PageEnginePresetName =
  | "engineering-blog"
  | "lona-marketing"
  | "loaf"
  | "tsh";

export type PageEnginePresetConfig = {
  preset: Preset<PageEngineNodeProps>;
  sectionSet: SectionSet<PageEngineNodeProps>;
  tokenSet: TokenSet;
};

export function resolvePageEnginePresetName(
  theme: ThemeRef,
): PageEnginePresetName {
  if (typeof theme === "string" && isPageEnginePresetName(theme)) return theme;
  if (typeof theme !== "string" && isPageEnginePresetName(theme.variant)) {
    return theme.variant;
  }
  return "engineering-blog";
}

export function isPageEnginePresetName(
  value: string,
): value is PageEnginePresetName {
  return value === "engineering-blog"
    || value === "lona-marketing"
    || value === "loaf"
    || value === "tsh";
}
